import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import PageModal from '../common/PageModal'
import Dropdown from '../common/Dropdown'
import LoadingSpinner from '../common/LoadingSpinner'
import EmptyPageResults from '../common/EmptyPageResults'
import SimpleButton from '../common/SimpleButton'
import TooltipedIcon from '../common/TooltipedIcon'
import {
  ArrowBackThickIcon,
  VideoPlayIcon,
  VerifiedIcon,
  ApertureIcon,
  UpdateIcon,
  CheckDoubleIcon,
  DownloadModernIcon,
  WasherSmallIcon,
  SterilizerSmallIcon,
  InformationIcon,
  ExternalUrlIcon,
} from '../../icons'
import { capitalizeFirstLetter, getFileIcon, getImageByModel, replaceExtension } from '../../utils/functions'
import { checkPermission, deviceNotificationsReadPermissions, userNotificationWritePermission } from '../../utils/permissionValidation'
import { gaCategories, trackEvent, gaActions } from '../../utils/ga4'
import { handleDocumentDownload } from '../../utils/documentUtils'
import { useAppContext } from '../../libs/contextLib'
import { useFirmwareSteps } from '../../hooks/useFirmwareSteps'
import './product-details-modal.scss'

const ProductDetailsModal = (props) => {
  const { t } = useTranslation()
  const { supportsColteneStore } = useAppContext()
  const {
    canAccessInstrumentTracking,
    selectedProduct,
    serials,
    selectedSerial,
    productSerialNickname,
    hasOnlineAccess,
    hasPrivacyPolicyChecked,
    hasUpdateAvailable,
    currentSoftwareVersion,
    latestSoftwareVersion,
    productIsAperture,
    isBravoProduct,
    isJeniProduct,
    lastCycles,
    documents,
    videos,
    displayedInstructionSoftware,
    uiSoftwares,
    uiControlSoftwares,
    firmwareVideo,
    relatedProducts,
    isICTrackProduct,
    linkedDevicesLimit,
    showLimitedLikedDevice,
    onSelectSerial,
    onShowNotifications,
    onShowBravoOnlineAccess,
    onShowJeniOnlineAccess,
    onDeleteProduct,
    onDisassociateProduct,
    handleOpenProductActivationStepsModal,
    handleOpenNicknameSetupModal,
    handleOpenDeleteNicknameModal,
    handleNavigateToProduct,
    handleNavigateToProductPage,
    handleNavigateToInstrumentTracking,
    handleNavigateToInstrumentTrackingReports,
    handleNavigateToStore,
    onShowCycleDetails,
    onDownloadFirmware,
    handleOpenDocumentsModal,
    handleOpenVideosModal,
    onSelectVideo,
    onShowLimitedLinkedDevices,
    showSpinner,
    cyclesLoading,
    closeModal,
    mapSerialToModel,
    isG4Device,
    syncBravoCycles,
    showFeatureDev,
  } = props
  const isHydrim112Model = selectedProduct?.model?.toLowerCase().includes('hydrim 112')
  const { renderModelSteps, renderProductSteps } = useFirmwareSteps()

  const productHeaderContent = () => {
    return (
      <div className="product-header" onClick={() => handleCloseModal()}>
        <div className="back-button">
          <div className="back-icon">
            <ArrowBackThickIcon />
          </div>
        </div>
        <p className="title">{t('back')}</p>
      </div>
    )
  }

  const selectSerial = (serialNr) => {
    onSelectSerial(serialNr)
  }

  const handleCloseModal = () => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: 'My Products Page: Mobile Product Details Modal Closed',
    })

    if (closeModal) {
      closeModal()
    }
  }

  const buildUserFriendlyDate = (date) => {
    if (date) {
      return new Date(date).toLocaleString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
    }

    return ''
  }

  const renderProductOnlineAccess = (associationActive) => {
    return <div className="online-access">{associationActive ? <VerifiedIcon /> : <VerifiedIcon className="no-access" />}</div>
  }

  const renderFirmwareSection = (softwares, titleKey) => {
    if (!softwares?.length) {
      return null
    }

    return (
      <>
        <div className="internal-section-title">{t(`firmware_context.${titleKey}`)}</div>
        <div className="firmware-executables-wrapper">
          {softwares.map((file, index) => (
            <div className="firmware-executable" key={index}>
              <button className="download-document" onClick={() => onDownloadFirmware(file)} disabled={showSpinner}>
                <DownloadModernIcon className="download-icon" />
              </button>
              {getFileIcon(file.filename)}
              <div className="file-name">{replaceExtension(file.label || file.filename)}</div>
            </div>
          ))}
        </div>
      </>
    )
  }

  return (
    <div className="product-details-modal-wrapper">
      <PageModal toggle onToggle={() => handleCloseModal()} headerContent={productHeaderContent()}>
        <div className="product-details-modal-content">
          {/* <div className="product-card">
            <div className="image-wrapper d-flex flex-align-center">
              <img src={getImageByModel(selectedProduct.model)} className="img" alt={selectedProduct.model} />
            </div>
            <div className="product-wrapper">
              <p className="product-name">
                {isICTrackProduct && showFeatureDev ? t([`products.${selectedProduct.model}`, selectedProduct.model]) : selectedProduct.model}
              </p>
              {selectedProduct.products?.length > 0 && (
                <p className="product-serials">{`${selectedProduct.products.length} ${t('nav.products').toLowerCase()}`}</p>
              )}
            </div>
          </div> */}
          {selectedSerial && !isICTrackProduct && (
            <div className="product-details-wrapper">
              <div className="product-status-wrapper">
                <div className="d-flex">
                  <div className="image-wrapper d-flex flex-align-center">
                    <img src={getImageByModel(selectedProduct.model)} className="img" alt={selectedProduct.model} />
                  </div>
                  <div className="product-serial-wrapper">
                    <div className="product-serial">{`${t('sn')}: ${selectedSerial.serial_number}`}</div>
                    {hasOnlineAccess && (
                      <div className="product-serial-subtitle">
                        {productSerialNickname ? (
                          <div className="nickname-wrapper">
                            <span className="product-nickname">{productSerialNickname}</span>
                            {hasOnlineAccess && (
                              <div className="nickname-actions-wrapper">
                                <span
                                  className={'delete-nickname' + (!hasOnlineAccess || productIsAperture ? ' disabled' : '')}
                                  onClick={() => hasOnlineAccess && !productIsAperture && handleOpenDeleteNicknameModal(true)}
                                >
                                  {t('delete')}
                                </span>
                                <span
                                  className={'edit-nickname' + (!hasOnlineAccess ? ' disabled' : '')}
                                  onClick={() => hasOnlineAccess && handleOpenNicknameSetupModal(true)}
                                >
                                  {t('edit')}
                                </span>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            className={'nickname-add-wrapper' + (!hasOnlineAccess ? ' disabled' : '')}
                            onClick={() => hasOnlineAccess && handleOpenNicknameSetupModal(true)}
                          >
                            {t('products.add_nickname')}
                          </div>
                        )}
                      </div>
                    )}
                    <div className="product-status-legend">
                      {canAccessInstrumentTracking && showFeatureDev && (
                        <TooltipedIcon
                          icon={<ApertureIcon className={!productIsAperture ? 'unavailable' : ''} />}
                          tooltipText={productIsAperture ? t('products.aperture_associated') : t('products.aperture_not_associated')}
                        />
                      )}
                      <TooltipedIcon
                        icon={<UpdateIcon className={!hasUpdateAvailable ? 'unavailable' : ''} />}
                        tooltipText={hasUpdateAvailable ? capitalizeFirstLetter(t('device_context.update_available')) : t('products.update_not_avilable')}
                      />
                      <TooltipedIcon
                        icon={<VerifiedIcon className={!hasOnlineAccess ? 'unavailable' : ''} />}
                        tooltipText={
                          hasOnlineAccess
                            ? capitalizeFirstLetter(t('device_context.online_access_active'))
                            : capitalizeFirstLetter(t('device_context.online_access_inactive'))
                        }
                      />
                      <TooltipedIcon
                        icon={<CheckDoubleIcon className={!hasPrivacyPolicyChecked ? 'unavailable' : ''} />}
                        tooltipText={
                          hasPrivacyPolicyChecked
                            ? capitalizeFirstLetter(t('device_context.privacy_policy_checked'))
                            : t('products.privacy_policy_not_accepted')
                        }
                      />
                    </div>
                  </div>
                </div>
                {selectedSerial.association_active &&
                  !isJeniProduct &&
                  ((checkPermission(props.userPermissions, userNotificationWritePermission) && isBravoProduct) ||
                    checkPermission(props.userPermissions, deviceNotificationsReadPermissions)) && (
                    <div className="d-flex">
                      <SimpleButton className="action-button" disabled={!hasOnlineAccess} onClick={() => onShowNotifications()}>
                        {t('events.device-notifications')}
                      </SimpleButton>
                    </div>
                  )}
              </div>

              {selectedSerial.association_active && isJeniProduct && (
                <SimpleButton
                  className="action-cancel-button"
                  title={t('device_context.delete_from_user_account')}
                  disabled={showSpinner}
                  onClick={() => {
                    onDisassociateProduct()
                  }}
                >
                  {t('device_context.delete_from_account')}
                </SimpleButton>
              )}

              {!selectedSerial.association_active && (
                <SimpleButton
                  className="action-cancel-button with-bottom-margin"
                  title={t('device_context.delete_from_user_account')}
                  disabled={showSpinner}
                  onClick={() => {
                    onDeleteProduct()
                  }}
                >
                  {t('device_context.delete_from_account')}
                </SimpleButton>
              )}

              {(isBravoProduct || isJeniProduct) && !selectedSerial.association_active && (
                <SimpleButton
                  className="submit-button with-bottom-margin"
                  onClick={() => {
                    if (isBravoProduct) {
                      onShowBravoOnlineAccess()
                    } else if (isJeniProduct) {
                      onShowJeniOnlineAccess()
                    }
                  }}
                >
                  {t('products.activate_online_access_now')}
                </SimpleButton>
              )}

              {hasUpdateAvailable && (
                <div className="product-software-wrapper">
                  <div className="update-wrapper">
                    <div className="info-wrapper">
                      <div className="section-title software-title">{t('device_context.update_available')}</div>
                      {isG4Device && (
                        <div className="title-version">
                          <span>{`${t('products.current_version')} `}</span>
                          <span className="current-version">{replaceExtension(currentSoftwareVersion)}</span>
                        </div>
                      )}
                      <div className="title-version">
                        <span>{`${t('products.latest_version')} `}</span>
                        <span className="latest-version">{replaceExtension(latestSoftwareVersion)}</span>
                      </div>
                    </div>
                    <div className="update-dot" />
                  </div>
                </div>
              )}

              {!selectedSerial.association_active && isG4Device && (
                <div className="activation-box-text">
                  <div className="icon-wrapper">
                    <InformationIcon />
                  </div>
                  <div className="activation-wrapper">
                    <div className="title">{t('products.activate_online_access')}</div>
                    <span>{isJeniProduct ? t('products.activation_message_jenievo') : t('products.activation_message')}</span>
                    <span className="activation-steps" onClick={() => handleOpenProductActivationStepsModal(true)}>
                      {t('products.click_to_activate_online_access')}
                    </span>
                  </div>
                </div>
              )}

              {isG4Device && !isJeniProduct && (
                <div className="product-cycles-wrapper">
                  <div className="section-title">{t('products.last_cycles')}</div>
                  <div className="cycles-wrapper">
                    {lastCycles.map((cycle, index) => (
                      <div key={index} className={'cycle-item-wrapper ' + `${cycle.className}`} onClick={() => onShowCycleDetails(cycle)}>
                        <div className="title">{cycle.title}</div>
                        <div className="time">{buildUserFriendlyDate(cycle.start)}</div>
                      </div>
                    ))}
                  </div>
                  {!cyclesLoading && lastCycles.length === 0 && (
                    <div className="no-cycles-wrapper">
                      <p className="disclaimer">{t('products.no_cycles_available')}</p>
                    </div>
                  )}
                  <div className="d-flex gap-8">
                    <SimpleButton className="action-button view-cycles-button" onClick={() => handleNavigateToProductPage()}>
                      {t('products.view_cycles_calendar')}
                    </SimpleButton>
                    {isBravoProduct && hasOnlineAccess && (
                      <SimpleButton className="action-button view-cycles-button" onClick={() => syncBravoCycles()} disabled={showSpinner}>
                        {t('device_context.sync_cycles')}
                      </SimpleButton>
                    )}
                  </div>
                </div>
              )}

              {!isJeniProduct && (
                <div className="product-firmware-wrapper">
                  <div className="section-title">{t('nav.firmware')}</div>
                  <div className="firmware-wrapper">
                    {displayedInstructionSoftware && (
                      <>
                        <div className="instruction-box-text">
                          <div className="icon-wrapper">
                            <InformationIcon />
                          </div>
                          <div className="instruction-wrapper">
                            <div className="title">{t('firmware_context.update_instructions')}</div>

                            {renderProductSteps(selectedProduct.model, firmwareVideo, onSelectVideo)}
                          </div>
                        </div>
                        <div className="internal-section-title">{t('firmware_context.instructions_other_documents')}</div>
                        <div className="firmware-documents-wrapper">
                          {displayedInstructionSoftware?.map((document, index) => (
                            <div className="firmware-documents d-flex" key={index}>
                              <div className="name-wrapper d-flex flex-align-center">
                                {getFileIcon(document.label)}
                                <div className="file-name">{replaceExtension(document.label)}</div>
                              </div>
                              <SimpleButton
                                className="action-button small-button limit-button"
                                onClick={() => onDownloadFirmware(document)}
                                disabled={showSpinner}
                              >
                                {t('download')}
                              </SimpleButton>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {!displayedInstructionSoftware && uiControlSoftwares && uiControlSoftwares.length > 0 && uiControlSoftwares[0].prefix === 'UC150' && (
                      <>
                        <div className="instruction-box-text">
                          <div className="icon-wrapper">
                            <InformationIcon />
                          </div>
                          <div className="instruction-wrapper">
                            <div className="title">{t('firmware_context.update_instructions')}</div>
                            {renderModelSteps('BioSonic UC150')}
                          </div>
                        </div>
                      </>
                    )}

                    {!isHydrim112Model && renderFirmwareSection(uiSoftwares, 'lcd_board_software')}
                    {renderFirmwareSection(uiControlSoftwares, 'lcd_main_board_software')}
                    {!displayedInstructionSoftware && uiSoftwares.length === 0 && uiControlSoftwares.length === 0 && (
                      <div className="no-firmware-wrapper">
                        <p className="disclaimer">{t('firmware_context.no_firmware_update_available')}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="product-documents-wrapper">
                <div className="section-title">{t('products.documents_available')}</div>
                <div className="documents-wrapper">
                  {documents.map((item, index) => (
                    <div
                      key={index}
                      className="document-item-wrapper"
                      onClick={() => {
                        handleDocumentDownload(item, gaCategories.productPage)
                      }}
                    >
                      <div className="image-wrapper">
                        <DownloadModernIcon />
                      </div>
                      <div className="image-wrapper rounded-image">{item.is_external_document ? <ExternalUrlIcon /> : getFileIcon(item.file_name)}</div>
                      <div className="title-wrapper">
                        <p className="title">{item?.document_title ? item?.document_title : item?.file_name}</p>
                        <p className="section">{item?.section_name}</p>
                      </div>
                    </div>
                  ))}
                </div>
                {documents.length === 0 && (
                  <div className="no-documents-wrapper">
                    <p className="disclaimer">{t('document_context.no_documents_yet')}</p>
                  </div>
                )}
                <SimpleButton className="action-button view-documents-button" disabled={documents.length === 0} onClick={() => handleOpenDocumentsModal()}>
                  {t('document_context.view_all_documents')}
                </SimpleButton>
              </div>

              <div className="product-videos-wrapper">
                <div className="section-title">{t('nav.videos')}</div>
                <div className="videos-wrapper">
                  {videos.map((video, index) => (
                    <div key={index} className="video-item-wrapper" onClick={() => onSelectVideo(video)}>
                      <div className="thumbnail-wrapper">
                        <div className="thumbnail-icon">
                          <VideoPlayIcon />
                        </div>
                        <img src={video.thumbnail_url} alt="video" />
                      </div>
                      <p className="title">{video.title}</p>
                    </div>
                  ))}
                </div>
                {videos.length === 0 && (
                  <div className="no-videos-wrapper">
                    <p className="disclaimer">{t('video_context.no_videos_yet')}</p>
                  </div>
                )}
                <SimpleButton className="action-button view-videos-button" disabled={videos.length === 0} onClick={() => handleOpenVideosModal()}>
                  {t('video_context.view_all_videos')}
                </SimpleButton>
              </div>
            </div>
          )}
          {!selectedSerial && !isICTrackProduct && (
            <EmptyPageResults className="fit-within-page" title={t('no_product_selected')} subtitle={t('troubleshoot.select-product')} />
          )}
          {isICTrackProduct && showFeatureDev && (
            <>
              <p className="serial-select-title">{`${t('products.linked_devices')} (${selectedProduct.products?.length})`}</p>
              <div className="linked-products-wrapper">
                {selectedProduct.products?.slice(0, showLimitedLikedDevice ? linkedDevicesLimit : selectedProduct.products.length)?.map((product, index) => (
                  <div
                    key={index}
                    className={'linked-product' + (product.isSciCanProduct ? ' with-navigation' : '')}
                    onClick={() => product.isSciCanProduct && handleNavigateToProduct(product.serial_number)}
                  >
                    <img src={getImageByModel(mapSerialToModel(product.serial_number))} className="product-image" alt="product" />
                    <div className="product-nickname">{product.unit_nickname}</div>
                    <div className="product-serial">{product.serial_number && `${t('sn')} ${product.serial_number}`}</div>
                  </div>
                ))}
              </div>
              {selectedProduct.products?.length > linkedDevicesLimit && showLimitedLikedDevice && (
                <div onClick={() => onShowLimitedLinkedDevices(false)} className="content-limiter">
                  {`+${selectedProduct.products.length - linkedDevicesLimit} ${t('more')}`}
                </div>
              )}
              {!showLimitedLikedDevice && (
                <div onClick={() => onShowLimitedLinkedDevices(true)} className="content-limiter">
                  {t('view_less')}
                </div>
              )}

              <div className="product-details-wrapper">
                <div className="product-cycles-wrapper">
                  <div className="section-title with-extra-information">{t('nav.instrument_tracking')}</div>
                  <div className="extra-information">{t('products.last_days')}</div>
                  <div className="cycles-wrapper ic-track-cycles-wrapper">
                    {lastCycles.map((cycle, index) => (
                      <div key={index} className={'cycle-item-wrapper ' + `${cycle.className}`} onClick={() => onShowCycleDetails(cycle)}>
                        <div className="icon-title-wrapper">
                          <div className="icon">
                            {cycle.type === 'washer' ? <WasherSmallIcon /> : <SterilizerSmallIcon />}
                            <div className="title">{cycle.serial_number ? `${t('sn')}: ${cycle.serial_number}` : cycle.nickName}</div>
                          </div>
                          <div className="cycle-num">{cycle.title}</div>
                        </div>
                      </div>
                    ))}
                    {!cyclesLoading && lastCycles.length === 0 && (
                      <div className="no-cycles-wrapper">
                        <p className="disclaimer">{t('products.no_cycles_available')}</p>
                      </div>
                    )}
                  </div>
                  <div className="cycles-navigation-buttons-wrapper">
                    <SimpleButton className="action-button" onClick={() => handleNavigateToInstrumentTracking()}>
                      {t('products.view_instrument_tracking_calendar')}
                    </SimpleButton>
                    <SimpleButton className="action-button" onClick={() => handleNavigateToInstrumentTrackingReports()}>
                      {t('products.view_instrument_reprocessing_report')}
                    </SimpleButton>
                  </div>
                </div>

                <div className="product-documents-wrapper">
                  <div className="section-title">{t('nav.documents')}</div>
                  <div className="documents-wrapper">
                    {documents.map((item, index) => (
                      <div key={index} className="document-item-wrapper" onClick={() => handleDocumentDownload(item, gaCategories.productPage)}>
                        <div className="image-wrapper">
                          <DownloadModernIcon />
                        </div>
                        <div className="image-wrapper rounded-image">{getFileIcon(item.file_name)}</div>
                        <div className="title-wrapper">
                          <p className="title">{item?.document_title ? item?.document_title : item?.file_name}</p>
                          <p className="section">{item?.section_name}</p>
                        </div>
                      </div>
                    ))}
                    {documents.length === 0 && (
                      <div className="no-documents-wrapper">
                        <p className="disclaimer">{t('document_context.no_documents_yet')}</p>
                      </div>
                    )}
                  </div>
                  <SimpleButton
                    className="action-button view-documents-button"
                    disabled={documents.length === 0}
                    onClick={() => handleOpenDocumentsModal(true)}
                  >
                    {t('document_context.view_all_documents')}
                  </SimpleButton>
                </div>

                <div className="product-videos-wrapper">
                  <div className="section-title">{t('nav.videos')}</div>
                  <div className="videos-wrapper">
                    {videos.map((video, index) => (
                      <div key={index} className="video-item-wrapper" onClick={() => onSelectVideo(video)}>
                        <div className="thumbnail-wrapper">
                          <div className="thumbnail-icon">
                            <VideoPlayIcon />
                          </div>
                          <img src={video.thumbnail_url} alt="video" />
                        </div>
                        <p className="title">{video.title}</p>
                      </div>
                    ))}
                    {videos.length === 0 && (
                      <div className="no-videos-wrapper">
                        <p className="disclaimer">{t('video_context.no_videos_yet')}</p>
                      </div>
                    )}
                  </div>
                  <SimpleButton className="action-button view-videos-button" disabled={videos.length === 0} onClick={() => handleOpenVideosModal(true)}>
                    {t('video_context.view_all_videos')}
                  </SimpleButton>
                </div>

                {supportsColteneStore && (
                  <div className="product-related-products-wrapper">
                    <div className="section-title">{t('products.related_products')}</div>
                    <div className="related-products-wrapper">
                      {relatedProducts.length === 0 && (
                        <div className="no-related-products-wrapper">
                          <p className="disclaimer">{t('products.no_related_products_available')}</p>
                        </div>
                      )}
                    </div>
                    <SimpleButton className="action-button view-store-button" onClick={() => handleNavigateToStore()}>
                      {t('products.go_to_store')}
                    </SimpleButton>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </PageModal>
      {showSpinner && (
        <div className="spinner-wrapper">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

function mapStateToProps({ userPermissions }) {
  return {
    userPermissions,
  }
}

export default connect(mapStateToProps)(ProductDetailsModal)

